import { projectsConstants } from './constants';

export const initialState = {
  data: [],
  pending: false,
};

export function projects(state = initialState, action) {
  switch (action.type) {
    case projectsConstants.GET_PROJECTS_REQUEST:
      return {
        ...initialState,
        pending: true,
      };
    case projectsConstants.GET_PROJECTS_SUCCESS:
      return {
        ...state,
        data: action.data.projects,
        meta: action.data.meta,
        pending: false,
      };
    case projectsConstants.GET_PROJECTS_FAILURE:
    default:
      return state;
  }
}
